/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RegisterEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('REGISTER_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class RegisterEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RegisterEnabledSettingParser.decode(input).map(res => new RegisterEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return RegisterEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RegisterEnabledSettingParser.encode(data);
    }
    static schema() {
        return RegisterEnabledSettingParser.schema();
    }
}
